export default {
  ENTER_REQUESTED: function (state, enterRequested) {
    state.enterRequested = enterRequested
  },
  SET_DEVICE_REQUIRED: function (state, deviceRequired) {
    state.deviceRequired = deviceRequired
  },
  APPROVED: function (state) {
    state.approved = true
  },
  DISAPPROVED: function (state) {
    state.disapproved = true
  },
  NO_PERMISSION: function (state) {
    state.noPermission = true
  },
  NO_MANAGER_IN_ROOM: function (state) {
    state.noManagerInRoom = true
  },
  ROOM_CLOSED: function (state) {
    state.roomClosed = true
  },
  // 승인 또는 비승인 처리(로직 없이 리스트에서 삭제)
  SET_UNCHECKED: function(state, flag) {
    state.unchecked = flag
  },
  APPROVAL: function (state, userId) {
    state.waitingList = state.waitingList.filter(user => !(user.userId === userId))
  },
  SET_WAITING_LIST: function (state, data) {
    state.waitingList = data
  },
  SET_ENABLED: function(state, enabled) {
    state.enabled = enabled
  },
  ADD_WAITING_USER: function (state, user) {
    state.waitingList.push(user);
  },
  CHANGE_ROLE_ID: function (state, {userId, roleId}) {
    state.waitingList.find(user => user.userId === userId).joinRoleId = roleId
  }
}
